"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./types");
var utils_1 = require("./utils");
var consoleErrorMessage = function (errorMessage) {
    console.error("log:".concat(errorMessage));
};
var url = {
    DEV: "https://service-aj1ejc81-1256119856.sh.apigw.tencentcs.com/release/beacon_dev",
    TEST: "https://service-opayzekp-1256119856.sh.apigw.tencentcs.com/release/beacon_test",
    PROD: "https://service-98wae8v5-1256119856.sh.apigw.tencentcs.com/release/beacon_prod",
};
var fetchLog = function (env, runtimeEnv, body) {
    if (!env) {
        consoleErrorMessage("环境变量env为必填项");
        return;
    }
    if (!body.tenantId) {
        consoleErrorMessage("tenantId为必填项");
        return;
    }
    if (!body.serviceCode) {
        consoleErrorMessage("serviceCode为必填项");
        return;
    }
    var src = "".concat(url[env]).concat((0, utils_1.paramSplice)(body));
    switch (runtimeEnv) {
        case types_1.EnumRuntimeEnv.WX:
            // 会在控制台报Unhandled promise rejection，原因是当前的地址返回的不是图片
            wx.getImageInfo({ src: src });
            break;
        case types_1.EnumRuntimeEnv.WINDOW:
            new Image().src = src;
            break;
        default:
            new Image().src = src;
    }
};
exports.default = fetchLog;
